import request from '@/common/request'
import { Atualizacao, carregarAtualizacoes, NovidadeDaApi } from '@/shareds/novidades/modelo'

/**
 * As atualizações vêm da API do almode-novidades (outro host, sem autenticação). As lidas ficam no
 * backend do ERP, por usuário, para seguir o usuário entre computadores.
 */

const API_URL = process.env.VUE_APP_NOVIDADES_API_URL || ''

export const apiDeNovidadesConfigurada = () => !!API_URL

let emCache: Promise<Atualizacao[]> | null = null

/** Busca uma vez por sessão; a lista e a leitura usam o mesmo resultado. Falha não fica em cache. */
export function buscarAtualizacoes(): Promise<Atualizacao[]> {
	if (!API_URL) return Promise.resolve([])
	if (!emCache) {
		emCache = fetch(`${API_URL}/novidades`)
			.then(async res => {
				if (!res.ok) throw new Error(`A API de novidades respondeu ${res.status}`)
				const dados: NovidadeDaApi[] = await res.json()
				if (!Array.isArray(dados)) throw new Error('A API de novidades não devolveu uma lista')
				return carregarAtualizacoes(dados)
			})
			.catch(erro => {
				emCache = null
				throw erro
			})
	}
	return emCache
}

const lidasNestaSessao = new Set<string>()

/** Ids das atualizações que o usuário logado já abriu. */
export async function buscarIdsLidos(): Promise<Set<string>> {
	const ids: string[] = await request.get('/novidades/lidas')
	return new Set([...(ids || []), ...lidasNestaSessao])
}

/** Marca como lida. Pode ser repetido sem erro. */
export async function marcarComoLida(id: string): Promise<void> {
	lidasNestaSessao.add(id)
	await request.put(`/novidades/lidas/${encodeURIComponent(id)}`)
}
